import React from "react";
import config from "../configData.json";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PayPalCheckout from "../components/PayPal/PayPalCheckout";
import { ToastContainer } from "react-toastify";
import { Validator, sanitizeInput } from "../components/Validation/Validator";
import ValidationSummary from "../components/Validation/ValidationSummary";
import {
  getAllFormElements,
  showValidationErrors,
  resetValidationErrors,
} from "../components/Utilities";
import Select from "react-select";
import countryList from "react-select-country-list";

let clientId: string = config.PAYPAL_CLIENTID;
let currencyCode: string = config.CURRENCY_CODE;

const location = window.location;

if (location !== null && location !== undefined) {
  if (location.hostname === "localhost") {
    //dev
    clientId = config.SANDBOX_PAYPAL_CLIENTID;
  }
}

export interface Props {
  Title: string;
}

interface State {
  fullName: string;
  email: string;
  addressLine1: string;
  addressLine2: string;
  cityTown: string;
  postZip: string;
  countries: any;
  selectedCountry: string;
  receiveUpdates: boolean;
  formErrors: any;
  isLoading: boolean;
  //recaptcha: any;
  //recaptchaResult: boolean;
  shipping: any;
  isValid: boolean;
}

//initialize paypal
const initialOptions = {
  clientId: clientId,
  currency: currencyCode,
  intent: "capture",
};

class Checkout extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    //let siteKey: string = config.PROD_RECAPTCHA_SITEKEY;
    this.state = {
      fullName: "",
      email: "",
      addressLine1: "",
      addressLine2: "",
      cityTown: "",
      postZip: "",
      countries: {},
      selectedCountry: "",
      receiveUpdates: false,
      formErrors: [],
      isLoading: false,
      //recaptcha: new Recaptcha(siteKey, "register"),
      //recaptchaResult: false,
      shipping: {},
      isValid: false,
    };
    this.handleBlurValidation = this.handleBlurValidation.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.handleFullNameChange = this.handleFullNameChange.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
    this.handleAddressLine1Change = this.handleAddressLine1Change.bind(this);
    this.handleAddressLine2Change = this.handleAddressLine2Change.bind(this);
    this.handleCityTownChange = this.handleCityTownChange.bind(this);
    this.handlePostZipChange = this.handlePostZipChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.handleCheckBoxChange = this.handleCheckBoxChange.bind(this);
  }
  /*recaptcha = async (data: any) => {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (result && result.success) {
        this.setState({
          recaptchaResult: result.success,
        });
      } else if (result !== null && result !== undefined) {
        setToaster({
          state: { error: true },
          message: "Failed: Errors encountered in recaptcha",
        });
      } else {
        setToaster({
          state: { error: true },
          message: "Failed: Errors encountered in recaptcha: " + result.Message,
        });
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
        this.setState({ isLoading: false });
        setToaster({
          state: { error: true },
          message: error.response ? error.message : "Unknown Error",
        });
      }
    };
    recaptcha({
      url: "Authentication/SiteVerify",
      data: data,
      successCallback,
      errorCallback,
    });
  };*/
  handleBlurValidation = (e: any) => {
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  handleFocus = (e: any) => {
    this.setState({ formErrors: [] }, () => {
      resetValidationErrors(e.target);
    });
  };
  handleFullNameChange = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ fullName: clean, isValid: false });
  };
  handleEmailChange = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ email: clean, isValid: false });
  };
  handleAddressLine1Change = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ addressLine1: clean, isValid: false });
  };
  handleAddressLine2Change = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ addressLine2: clean, isValid: false });
  };
  handleCityTownChange = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ cityTown: clean, isValid: false });
  };
  handlePostZipChange = (e: any) => {
    let clean = sanitizeInput(e.target.value, e.target.type);
    this.setState({ postZip: clean, isValid: false });
  };
  handleCountryChange = (e: any) => {
    this.setState({ selectedCountry: e });
  };

  handleCheckBoxChange = (e: any) => {
    this.setState({ receiveUpdates: e.target.checked });
    //is this a required field
    let errors = Validator({ fields: e.target });
    if (errors.length === 0) {
      this.setState({ formErrors: [] }, () => {
        resetValidationErrors(e.target);
      });
    } else {
      this.setState({ formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  /*getRecaptchaToken = async (): Promise<any> => {
    try {
      return new Promise(async (resolve: any, reject: any) => {
        let token: any = await this.state.recaptcha.getToken();
        if (token !== null && token !== undefined) {
          return resolve(token);
        } else {
          return reject("");
        }
      });
    } catch {
      return new Promise((reject: any) => {
        return reject("");
      });
    }
  };*/
  getShippingAddress = (): any => {
    return this.state.shipping;
  };
  saveAddress = async (e: any) => {
    e.preventDefault();
    /*let result: any = await this.getRecaptchaToken();

    //this still needs to be implemented
    //need to wait for this result before moving on
    if (result !== "") {
      await this.recaptcha({ Response: result });
    }*/

    const fullName: string = this.state.fullName.trim();
    const email: string = this.state.email.trim();
    const addressLine1: string = this.state.addressLine1.trim();
    const addressLine2: string = this.state.addressLine2.trim();
    const cityTown: string = this.state.cityTown.trim();
    const postZip: string = this.state.postZip.trim();
    const country: any = this.state.selectedCountry;
    let form = document.getElementById("shippingForm");
    let allFormElements = getAllFormElements({ element: form ? form : e });
    let errors = Validator({ fields: allFormElements });

    // do select
    if (country === "") {
      let error = {
        fieldName: "countriesSelect",
        message: "Country is required",
      };
      errors?.push(error);
    }

    if (errors.length === 0) {
      //update state
      let shippingDetails: any = {
        full_name: fullName,
        email_address: email,
        address_line_1: addressLine1,
        address_line_2: addressLine2,
        admin_area_2: cityTown,
        postal_code: postZip,
        country_code: country.value,
      };
      this.setState(
        { isValid: true, shipping: shippingDetails, formErrors: [] },
        () => {
          resetValidationErrors(e.target);
        }
      );
    } else {
      this.setState({ isValid: false, formErrors: errors }, () => {
        showValidationErrors(this.state.formErrors);
      });
    }
  };
  CustomStyle = {
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "black" : "white",
      color: state.isSelected ? "white" : "black",
    }),
  };
  componentDidMount(): void {
    this.setState({ countries: countryList().getData() });
  }

  render() {
    return (
      <div className="wrapper">
        <div className="section">
          <div className="container">
            <h3 className="section-title">{this.props.Title}</h3>
            <hr />
            <div className="col-md-6">
              <div className="card-form">
                <h5 className="card-title">1. Shipping</h5>
                <hr />
                <ValidationSummary Errors={this.state.formErrors} />
                <form id="shippingForm" onSubmit={this.saveAddress}>
                  <div className="form-group">
                    <label htmlFor="fullName" className="label-dark">
                      Full Name
                    </label>
                    <input
                      id="fullName"
                      className="form-control border-input"
                      type="text"
                      value={this.state.fullName}
                      onChange={this.handleFullNameChange}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="Full Name"
                      data-required="true"
                      data-validationname="Full Name"
                      data-id="fullName"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email" className="label-dark">
                      Email Address
                    </label>
                    <input
                      id="email"
                      className="form-control border-input"
                      type="email"
                      value={this.state.email}
                      onChange={this.handleEmailChange}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="Email Address"
                      data-required="true"
                      data-validationname="Email Address"
                      data-id="email"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="addressLine1" className="label-dark">
                      Address Line 1
                    </label>
                    <input
                      id="addressLine1"
                      className="form-control border-input"
                      type="text"
                      value={this.state.addressLine1}
                      onChange={this.handleAddressLine1Change}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="Address Line 1"
                      data-required="true"
                      data-validationname="Address Line 1"
                      data-id="addressLine1"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="addressLine2" className="label-dark">
                      Address Line 2
                    </label>
                    <input
                      id="addressLine2"
                      className="form-control border-input"
                      type="text"
                      value={this.state.addressLine2}
                      onChange={this.handleAddressLine2Change}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="Address Line 2"
                      data-required="false"
                      data-validationname="Address Line 2"
                      data-id="addressLine2"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="cityTown" className="label-dark">
                      City/Town
                    </label>
                    <input
                      id="cityTown"
                      className="form-control border-input"
                      type="text"
                      value={this.state.cityTown}
                      onChange={this.handleCityTownChange}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="City / Town"
                      data-required="true"
                      data-validationname="City / Town"
                      data-id="cityTown"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="postZip" className="label-dark">
                      Post/Zip Code
                    </label>
                    <input
                      id="postZip"
                      className="form-control border-input"
                      type="text"
                      value={this.state.postZip}
                      onChange={this.handlePostZipChange}
                      onBlur={this.handleBlurValidation}
                      onFocus={this.handleFocus}
                      placeholder="Post / Zip Code"
                      data-required="true"
                      data-validationname="Post / Zip Code"
                      data-id="postZip"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="country" className="label-dark">
                      Country
                    </label>
                    <Select
                      value={this.state.selectedCountry}
                      onChange={this.handleCountryChange}
                      options={this.state.countries}
                      styles={this.CustomStyle}
                    />
                  </div>
                  {/*<div className="form-group">
                    <div className="form-group">
                      <Checkbox
                        id="chkUpdates"
                        label="Check if you would like to receive updates"
                        checked={false}
                        onSelecting={this.handleCheckBoxChange}
                        datarequired={false}
                        labelClass="label-dark"
                        data-validationname="Updates"
                        data-id="chkUpdates"
                      />
                    </div>
                  </div>*/}
                  <div className="form-group">
                    <button
                      type="submit"
                      className="btn btn-default btn-round"
                      data-id="shippingButton"
                    >
                      Confirm Shipping Address
                    </button>
                  </div>
                </form>
                <ToastContainer autoClose={2000} />
              </div>
            </div>
            <div
              className="col-md-6"
              style={{ display: this.state.isValid ? "block" : "none" }}
            >
              <div className="card-form">
                <h5 className="card-title">2. Payment</h5>
                <hr />
                <PayPalScriptProvider options={initialOptions}>
                  <PayPalCheckout
                    Title={this.props.Title}
                    onCreateOrder={this.getShippingAddress}
                  />
                </PayPalScriptProvider>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Checkout;
